module.exports = __webpack_public_path__ + "img/155.99d36492.png";